import { css, keyframes } from 'styled-components'

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`

export const fadeInOutAnimation = css`
  ${props=> props.theme.breakpoints.up('sm')} {
    visibility: hidden;
    animation: ${fadeOut} 1s ease;

    &.is-selected {
      visibility: visible;
      animation: ${fadeIn} 1s ease;
    }
  }
`